import * as apiHelper from './../helpers/apiHelper';
import * as loadingActions from './loadingActions';

export var getPosts = () => {
	return (dispatch, getState) => {
		var url = "posts";
		
		return apiHelper.apiRequest(url, 'get', null, dispatch, getState).then((res) => {
			if (res.ok) {
				return res.json;
			} else {
				return null;
			}
		});
	};
};

export var savePost = (formData) => {
	return (dispatch, getState) => {
		dispatch(loadingActions.setSaving());
		var url = "posts";
		
		return apiHelper.apiRequest(url, 'post', formData, dispatch, getState).then((res) => {
			dispatch(loadingActions.removeLoading());
			return res.ok ? res.json : res.errors;
		});
	};
};

export var hidePost = (id) => {
	return (dispatch, getState) => {
		dispatch(loadingActions.setSaving());
		const url = "posts/" + id;

		return apiHelper.apiRequest(url, 'delete', null, dispatch, getState).then((res) => {
			dispatch(loadingActions.removeLoading());
			return res.ok;
		});
	};
};

export var getFeeds = (filter, lastDate) => {
	return (dispatch, getState) => {
		var url = "feeds";
		
		var parameters = [];
		if (lastDate && lastDate.length > 0)
			parameters.push("end_date=" + lastDate); 
		
		if (filter && filter.length > 0)
			parameters.push('filter=' + filter);

		if (parameters.length > 0)
			url += "?" + parameters.join("&");

		return apiHelper.apiRequest(url, 'get', null, dispatch, getState).then((res) => {
			if (res.ok) {
				return res.json;
			} else {
				return null;
			}
		});
	};
};

export var deleteFeed = (id) => {
	return (dispatch, getState) => {
		dispatch(loadingActions.setSaving());
		var url = "feeds/" + id;
		
		return apiHelper.apiRequest(url, 'delete', null, dispatch, getState).then((res) => {
			dispatch(loadingActions.removeLoading());
			return res.ok;
		});
	};
};


// WEBPACK FOOTER //
// ./src/actions/accountActions.js